import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './AddList.module.scss';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';
import * as hf from 'Flow2/util/helperFunctions.js';
import * as actions from 'store/actions/index';
import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isPMDB } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faCheck, faTimes, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const SinglePassword = (props) => {
    const copy = () => {
        navigator.clipboard.writeText(props.pwd).then(function () {
            console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    }
    
    let out = (
        <>
        <span className={classes.RowData}>{props.pwd}</span>
        <span onClick={copy} className={classes.Copy}>
            <FontAwesomeIcon icon={faClipboard} color="" title={props.intl.formatMessage({ id: "common.copyToClipBoard" })} />
        </span>
        </>
    );
    
    if(props.edit && isPMDB() && (props.user.role === 'level6' || props.user.role === 'level5')) {
        const tooltip = props.intl.formatMessage({ id: "tooltip.password.rules", defaultMessage: "Tooltip" });
        
        out = (
            <>
            <Input
                value={props.new === false ? props.pwd : props.new}
                elementConfig={{type: 'text', placeholder: props.intl.formatMessage({ id: "common.password", defaultMessage: "Passwort" })}}
                changed={(evt) => { props.set(evt.target.value); }}/>
            <span onClick={props.add} className={classes.Copy}>
                <FontAwesomeIcon icon={faCheck} color="" title={props.intl.formatMessage({ id: "common.add" })} />
            </span>
            <span onClick={props.reset} className={classes.Copy}>
                <FontAwesomeIcon icon={faTimes} color="" title={props.intl.formatMessage({ id: "common.cancel" })} />
            </span>
            
        
            <span data-html="true" className={[classes.Tooltip].join(' ')} data-tooltip={tooltip}>
                <FontAwesomeIcon icon={faQuestionCircle} />
            </span>
            </>
        );
    }
     return (
         <FlexRow  className={[classes.Row, classes.Pwd, props.invalid ? classes.Invalid : ""].join(' ')}>
            <span className={classes.RowData}><FormattedMessage id="common.password" /></span>
            { out }
        </FlexRow>
    );
}

const AddListRow = (props) => {
    let img = "";
    if(props.canRemove) {
        img = (<span><img alt="" className="pointer" onClick={props.remove} src={iconDelete} /></span>);
    }
    
     return (<FlexRow  className={[classes.Row, classes[props.canRemove]].join(' ')}>
                    <span onClick={props.click} className={classes.RowData}>{props.element.name}</span>
					<span onClick={props.click} className={classes.RowData}>{props.element.email}</span>
					{/*<span onClick={props.click} className={classes.RowData}>{props.element.pwd}</span>*/}
                    {img}
                </FlexRow>);
}

const AddListHeader = (props) => {
	let img = "";
    if(props.canRemove) {
        img = (<span><img alt="" className={classes.RowDataHide} src={iconDelete} /></span>);
    }
	
     return (<FlexRow  className={[classes.Row, classes[props.canRemove]].join(' ')}>
                    <span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.name" /></span>
					<span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.email" /></span>
					{/*<span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.password" /></span>*/}
					{img}
                </FlexRow>);
}

const AddListInput = (props) => {
    if(!props.showInput) {
        return "";
    }
    
    let addContact = "";
    if (props.config.ftvContacts) {
        
        return(
            <FlexRow className={[classes.Control, classes.Seperator, 'relative'].join(' ')}>
                <Button
                    key="ContactsToRoom"
                    btnType="Dark"
                    clicked={() => {
                        props.ftvContactsSetRoom(props.id);
                        props.history.push({
                            pathname: "/contacts"
                        });
                    }}>
                    <FormattedMessage id="page.rooms.addContacts" defaultMessage="Add Contacts" />
                </Button>
            </FlexRow>
        );
    }
    
    return (
        <FlexColumn>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.name}
                    elementConfig={{type: 'text', placeholder:"name"}}
                    changed={(event) => { props.changed({ ...props.element, name: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.email}
                    elementConfig={{type: 'text', placeholder:"email"}}
                    changed={(event) => { props.changed({ ...props.element, email: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Control, 'relative'].join(' ')}>
                {addContact}
            
                <Button btnType="Red" clicked={props.add}><FormattedMessage id="common.add" /></Button>
					{/*<Button btnType="White" clicked={props.clear}><FormattedMessage id="common.cancel" /></Button>*/}
            </FlexRow>
        </FlexColumn>
           );
}

class RoomUserList extends React.Component {
    
    constructor(props){
		super(props);
		this.state = {
           // element: this.createNewElement(),
            newPwd: false,
            invalid: false,
            index: -1,
            data: props.data || [],
            showList: props.showList || true,
            showInput: props.add ? true : false,
            canRemove: props.remove ? true : false,
			password: props.pwd || RoomUserList.getPassword(props)//props.singlePassword || hf.getRandomString(8, "-.,_:;!§$%&/")
		};
        
		this.state.element = this.createNewElement();
    }
	
	static getPassword(props) {
		if(!props.singlePassword) {
			return "";
		}
		
		const pwd = hf.getRandomString(12);
        
        const obj = {
            pwd: pwd,
            members: []
        }
        
		if(props.add) {
			props.add(JSON.stringify(obj));
		}
		
		return pwd;
	}
    
    createNewElement = () => {
        return {
                name: "",
                email: "",
                id: "P" + hf.getRandomString(7),
                pwd: hf.getRandomString(12)
            };
    }
    
    onChangedHandler = (element) => {
        this.setState({ element: element });
    }
    
    onSelect = (element, index) => {
        if(!element.name || !element.email) {
            return;
        }
        
        const data = this.state.data;
        if(index > -1) {
            data[index] = element;
        } else {
            data.push(element);
        }
        
        const obj = {
            pwd: this.state.password,
            members: data
        }
        
        this.setState({ element: this.createNewElement(), data: data, index: -1 });
		this.props.add(JSON.stringify(obj));
    }
    
    onRemoveClick = (index) => {
        const data = this.state.data;
        data.splice(index, 1);
        this.setState({ element: this.createNewElement(), data: data, index: -1 });
        
        const obj = {
            pwd: this.state.password,
            members: data
        }
        
        this.props.add(JSON.stringify(obj));
        //this.props.add(JSON.stringify(data));
    }
    
    onRowClick = (element, index) => {
        this.setState({element: element, index: index});
    }
    
    onClearInput = () => {
        this.setState({ element: this.createNewElement(), index: -1 });
    }
    
    createList = () => {
        if(!this.state.showList) {
            return "";
        }
        
        return this.createRowList();
    }
    
    createRowList = () => {
        const rows = this.state.data.map((element, index) => {
            return (
                <AddListRow
                    key={element.id}
                    element={element}
                    click={() => {this.onRowClick(element, index)}}
                    remove={() => this.onRemoveClick(index)}
                    canRemove={this.state.canRemove} />
            );
        });
        
        return (
            <FlexColumn className={classes.List}>
				{ rows.length ? <AddListHeader canRemove={this.state.canRemove} /> : "" }
                {rows}
            </FlexColumn>
        );
    }
    
     setPwd = (pwd) => {
        this.setState({ newPwd: pwd });
    }
    
    addPwd = () => {
        if(this.checkPwd(this.state.newPwd)) {
            const obj = {
                pwd: this.state.newPwd,
                members: this.state.data
            }
            
            this.props.add(JSON.stringify(obj));
            
            this.setState({ password: this.state.newPwd, newPwd: false, invalid: false });
            
        } else {
            this.setState({ invalid: true });
        }
    }
    
    resetPwd = () => {
        this.setState({ newPwd: false, invalid: false });
    }
    
    checkPwd = (pwd) => {
        // at least 12 signs
        if(pwd.length < 12) return false;
        
        // uppercase letter
        const rule1 = /(?=.*[A-Z])/;
        // lowercase letter
        const rule2 = /(?=.*[a-z])/;
        // number
        const rule3 = /(?=.*\d)/;
        // special char
        const rule4 = /(?=.*\W)/;
        // all rules
        const rules = [rule1,rule2,rule3,rule4];
        // test all rules
        const result = rules.map(rule => rule.test(pwd));
        // count how often rule is matched
        const count = result.filter(val => val === true).length;
        
        // true if 3 or more matches of the rules
        return count >= 3;
    }
    
    render = () => {
        const input = (<AddListInput
                            id={this.props.id}
                            config={this.props.config}
                            ftvContactsSetRoom={this.props.ftvContactsSetRoom}
                            history={this.props.history}
                            showInput={this.state.showInput}
                            element={this.state.element}
                            changed={( element ) => this.onChangedHandler( element )}
                            clear={this.onClearInput}
                            add={() => {this.onSelect(this.state.element, this.state.index)}} />);
        
        return (
            <FlexColumn className={classes.AddList}>
				{ 
                    this.state.password && this.props.singlePassword ? 
                    <SinglePassword 
                        pwd={ this.state.password } 
                        intl={this.props.intl} 
                        edit={this.state.showInput} 
                        add={this.addPwd} 
                        reset={this.resetPwd} 
                        set={this.setPwd} 
                        new={this.state.newPwd}
                        invalid={this.state.invalid}
                        user={this.props.user}/> 
                    : "" 
                }
                { this.createList() }
                {input}
            </FlexColumn>
        );
    }
    
    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState) {
            return {
                input: nextProps.add ? prevState.input : "",
                data: nextProps.data || [],
                showList: nextProps.showList || true,
                showInput: (nextProps.add && true) || false,
                canRemove: (nextProps.remove && true) || false,
                password: prevState.password || RoomUserList.getPassword(nextProps) //nextProps.singlePassword || hf.getRandomString(8, "-.,_:;!§$%&/")
            }; 
        }
        
        return null;
    }

};

const mapStateToProps = (state, ownProps) => {
    return {
        config: state.ui.config,
        user: state.auth.user
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ftvContactsSetRoom: (id) => dispatch(actions.ftvContactsSetRoom(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(RoomUserList)));
